import {
  INIT,
  INIT_SUCCESS,
  INIT_ERROR,
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_SUCCESS,
  LOAD_USER,
} from './actions';

const initial = {
  user: null,
  error: null,
  salt: null,
  loading: false,
  initLoading: false,
  userLoading: false,
};

const login = state => ({
  ...state,
  user: null,
  error: null,
  salt: null,
  loading: true,
});

const init = state => ({
  ...state,
  salt: null,
  initLoading: true,
});

const initSuccess = (state, { salt }) => ({
  ...state,
  salt,
  initLoading: false,
});

const initError = state => ({
  ...state,
  salt: null,
  initLoading: false,
});

const loginSuccess = (state, { user }) => ({
  ...state,
  user,
  error: null,
  loading: false,
});

const loginError = (state, { error }) => ({
  ...state,
  error,
  user: null,
  loading: false,
});

const logout = state => ({
  ...state,
  user: null,
  error: null,
});

const loadCurrentUser = state => ({
  ...state,
  loading: true,
});

export default (state = initial, action) => {
  const reducer = {
    [INIT]: init,
    [INIT_SUCCESS]: initSuccess,
    [INIT_ERROR]: initError,
    [LOGIN]: login,
    [LOGIN_SUCCESS]: loginSuccess,
    [LOGIN_ERROR]: loginError,
    [LOGOUT_SUCCESS]: logout,
    [LOAD_USER]: loadCurrentUser,
  }[action.type];

  return reducer ? reducer(state, action) : state;
};
